export const OMP_ACCOUNT_TYPE = {
    ORGANIZATION : 'ORGANIZATION',
    INDIVIDUAL: 'INDIVIDUAL',
    PUBLIC_GOVERNMENT: 'PUBLIC_GOVERNMENT'
}
